// extracted by mini-css-extract-plugin
export var cardIcon = "_1b-5";
export var cardIconUnframed = "_1b-9";
export var checkboxCard = "_1b-0";
export var checkboxCardSelected = "_1b-4";
export var disabled = "_1b-2";
export var interactive = "_1b-1";
export var outerBorder = "_1b-3";
export var spacerMedium = "_1b-8";
export var spacerSmall = "_1b-7";
export var spacerXsmall = "_1b-6";